import { buildErrorsFromMsgs, buildErrorsFromResponse } from '../utils/errorHandling';

export const SHOW_ORDER_STATUS_ACTION = 'SHOW_ORDER_STATUS_ACTION';
export const ORDER_STATUS_DATA = 'ORDER_STATUS_DATA';
export const CHECK_ORDER_STATUS = 'CHECK_ORDER_STATUS';
export const ORDER_STATUS_SUCCESS = 'ORDER_STATUS_SUCCESS';
export const ORDER_STATUS_FAILURE = 'ORDER_STATUS_FAILURE';
export const ORDER_STATUS_REDIRECT = 'ORDER_STATUS_REDIRECT';

/**
 * Order status form data
 * @param formData {Object} Map of the form data
 * @param msgs {Array} List of error messages on the form (on client-side validation)
 * @param previousMsgs {Array} List of previous error messages on the form (on client-side validation).
 */
export function sendOrderStatusData(formData, msgs, previousMsgs) {
    const convertedMsgs = buildErrorsFromMsgs(msgs);
    const redraw = JSON.stringify(previousMsgs) !== JSON.stringify(convertedMsgs);

    return {
        type: ORDER_STATUS_DATA,
        payload: {
            data: formData,
            msgs: convertedMsgs,
            redraw: redraw
        }
    };
}

export function orderStatusSuccess(response) {
    return {
        type: ORDER_STATUS_SUCCESS,
        payload: {
            data: response,
            requestType: ORDER_STATUS_SUCCESS
        }
    };
}

export function orderStatusFailure(error) {
    return {
        type: ORDER_STATUS_FAILURE,
        error: true,
        payload: {
            data: error.entity
        }
    };
}
